import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface PromotionTagPayload {
  name: string;
}


@Component({
  selector: 'app-add-promotional-tag',
  standalone: false,
  templateUrl: './add-promotional-tag.html',
  styleUrl: './add-promotional-tag.scss',
})
export class AddPromotionalTag implements OnInit{
  pageTitle =
    'Add Special Promotion Tag';

  pageSubtitle =
    'Create a special promotional tag for courses.';

  promotionTagForm!: FormGroup;

  isSubmitted = false;
  isSaving = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  get nameControl(): AbstractControl {
    return this.promotionTagForm.get(
      'name'
    ) as AbstractControl;
  }

  submitPromotionTag(): void {
    this.isSubmitted = true;

    if (
      this.promotionTagForm.invalid ||
      this.isSaving
    ) {
      this.promotionTagForm.markAllAsTouched();
      return;
    }

    const formValue =
      this.promotionTagForm.getRawValue();

    const payload: PromotionTagPayload = {
      name: formValue.name.trim()
    };

    this.isSaving = true;

    console.log(
      'Promotion-tag payload:',
      payload
    );

    /*
    Replace the timeout with your API:

    this.promotionTagService
      .createPromotionTag(payload)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.router.navigate([
            '/admin/course-reference/promotional-tag'
          ]);
        },
        error: (error) => {
          console.error(
            'Promotion-tag creation failed:',
            error
          );
        }
      });
    */

    setTimeout(() => {
      this.isSaving = false;
      this.isSubmitted = false;

      this.router.navigate([
        '/admin/course-reference/promotional-tag'
      ]);
    }, 800);
  }

  cancel(): void {
    window.history.back();
  }

  private initializeForm(): void {
    this.promotionTagForm =
      this.formBuilder.group({
        name: [
          '',
          [
            Validators.required,
            Validators.maxLength(100)
          ]
        ]
      });
  }
}
